

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var style = {
    backdropStyle: {
        background: 'transparent',
        position: 'fixed',
        width: '100%',
        height: '100%',
        left: 0,
        top: 0,
        overflow: 'hidden',
        zIndex: '99999',
        display: '-webkit-box',
        WebkitBoxOrient: 'horizontal',
        WebkitBoxPack: 'center',
        WebkitBoxAlign: 'center'
    },
    contentStyle: {
        position: 'absolute',
        width: '3.125rem',
        height: '2.8125rem',
        color: '#fff',
        textAlign: 'center',
        fontSize: '0.34375rem',
        borderRadius: '0.1875rem',
        background: '#000',
        opacity: '0.9',
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitBoxAlign: 'center'
    },
    loadingIconStyle: {
        display: 'block',
        width: '1.25rem',
        height: '1.25rem',
        margin: '0.5625rem auto 0.25rem',
        background: 'url(data:image/gif;base64,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) no-repeat center center',
        backgroundSize: '0.9375rem 0.9375rem'
    }
};

var Layer = function (_Component) {
    _inherits(Layer, _Component);

    function Layer(props) {
        _classCallCheck(this, Layer);

        return _possibleConstructorReturn(this, (Layer.__proto__ || Object.getPrototypeOf(Layer)).call(this, props));
    }

    _createClass(Layer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var wrap = this.refs.wrap;
            var item = this.refs.content;

            var bodyRect = document.body.getBoundingClientRect();
            var spanRect = item.getBoundingClientRect();
            var zIndex = item.style.zIndex;

            item.style.position = "fixed";
            item.style.left = "50%";
            item.style.top = "50%";
            item.style.marginLeft = -spanRect.width / 2 + "px";
            item.style.marginTop = -spanRect.height / 2 + "px";

            setTimeout(function () {
                item.style.zIndex = zIndex;
            }, 0);
        }
    }, {
        key: 'render',
        value: function render() {
            var backdropStyle = style.backdropStyle;
            var contentStyle = style.contentStyle;
            var loadingIconStyle = style.loadingIconStyle;

            if (this.props.loadingIconStyle) {
                for (var _style in this.props.loadingIconStyle) {
                    loadingIconStyle[_style] = this.props.loadingIconStyle[_style];
                }
            }

            if (this.props.backdropStyle) {
                for (var _style2 in this.props.backdropStyle) {
                    backdropStyle[_style2] = this.props.backdropStyle[_style2];
                }
            }

            if (this.props.contentStyle) {
                for (var _style3 in this.props.contentStyle) {
                    contentStyle[_style3] = this.props.contentStyle[_style3];
                }
            }
            console.log(this.props.content);
            return _react2.default.createElement(
                'div',
                { className: 'loading-wrap', style: backdropStyle, ref: 'wrap' },
                _react2.default.createElement(
                    'div',
                    { className: 'loading-content', style: contentStyle, ref: 'content' },
                    _react2.default.createElement('i', { className: 'loading-icon', style: loadingIconStyle }),
                    _react2.default.createElement(
                        'div',
                        { className: 'loading-txt' },
                        this.props.content
                    )
                )
            );
        }
    }]);

    return Layer;
}(_react.Component);

Layer.defaultProps = {
    content: 'Loading',
    contentStyle: {},
    backdropStyle: {},
    loadingIconStyle: {}

};


module.exports = {
    show: function show(cfg) {
        cfg = cfg || {};

        if (this.layer) {
            this.destroy();
        }

        cfg.content = typeof cfg.content !== 'undefined' ? cfg.content : 'Loading';

        var mountNode = this.createMountNode();

        this.layer = _reactDom2.default.render(_react2.default.createElement(Layer, cfg), mountNode);
    },

    hide: function hide() {
        if (this.layer) {
            this.destroy();
        }
    },

    // 创建组件插入的DOM节点
    createMountNode: function createMountNode() {
        this.mountNode = document.createElement("div");
        $(document.body).append(this.mountNode);
        return this.mountNode;
    },

    destroy: function destroy() {
        _reactDom2.default.unmountComponentAtNode(this.mountNode);
        $(this.mountNode).remove();
        delete this.layer;
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/c-up-loading/dist/index.js
// module id = 696
// module chunks = 0